import {
  EXTERIOR_COLOR,
  HISTORY_INFO,
  EXCLUDE_HISTORY_INFO,
  DEAL_TYPE,
  DELIVERY_TYPE,
  FEATURE,
  INTERIOR_COLOR,
  CYLINDERS_COUNT,
  TRANSMISSION,
  DRIVE_TRAIN,
  FUEL_TYPE,
  OPTION,
  SPECIAL_IDENTIFIER,
  TRIM,
  YEAR,
  MILEAGE,
  MAKE,
  MODEL,
  RADIUS,
  BODY_TYPE,
  VEHICLE_STYLE,
  INVENTORY_TYPE,
  DISPLAY_PRICE,
  LEASE_PAYMENT,
  LOAN_PAYMENT,
  RECENTLY_LISTINGS,
  PRICE_DROP,
  COMBINE_MPG,
  ELECTRICITY_RANGE,
  TRUCK_CAB_SIZE,
  BED_LENGTH,
  DISPLACEMENT,
  REAR_WHEELS,
  ENGINE_TYPE,
  HOME_DELIVERY,
  COMFORT_CONVENIENCE,
  SAFETY,
  ENGINE_EXTERIOR,
  ENTERTAINMENT,
  PAYMENT_TYPE,
  WITH_PHOTO,
  WITH_PRICE,
  EXCLUDE_IN_TRANSIT,
  WITH_FEES_INCLUDED,
  BATTERY_RANGE_SCORE,
  CREDIT_PROVIDER,
  TOTAL_SEATING,
  EDITORIAL_RATING,
  EDMUNDS_TOP_RATED,
  EDITORIAL_LABEL,
  SELF_DRIVING_LEVEL,
  EV_ELIGIBLE,
  SELLER_TYPE,
} from 'site-modules/shared/constants/allowed-inventory-request-params';
import { EDITORIAL_RATING_TO_SHOW, FACETS_CONTROLS } from 'site-modules/shared/constants/inventory/facets-config';
import {
  LOCATION_GROUP,
  MM_GROUP,
  YEAR_GROUP,
  CONDITION_GROUP,
  PRICE_PAYMENT_GROUP,
  CREDIT_PROVIDER_GROUP,
  RATING_GROUP,
  MILEAGE_GROUP,
  HISTORY_GROUP,
  MODEL_TYPE_GROUP,
  TRIM_GROUP,
  MPG_GROUP,
  EXT_COLOR_GROUP,
  INT_COLOR_GROUP,
  ELECTRIC_DETAILS_GROUP,
  ENGINE_GROUP,
  FEATURES_GROUP,
  OPTIONS_GROUP,
  VEHICLE_LISTING_DETAILS_GROUP,
  TRUCK_DETAILS_GROUP,
  TOTAL_SEATING_GROUP,
  PRICE_PAYMENT_TABS_SUBGROUP,
  LISTING_DETAILS,
  EDITORIAL_RATING_GROUP,
  SELLER_TYPE_GROUP,
} from 'site-modules/shared/constants/inventory/filters-constants';
import { EdmundsTested } from 'site-modules/shared/components/inventory/usurp-editorial-rating-filter/edmunds-tested';

export function getFacetCreativeId(str) {
  return `edm-entry-facets-${str}`;
}

const DELIVERY_SUBGROUP = 'delivery';
const VEHICLE_RATING_SUBGROUP = 'vehicle_rating';

export const MILES = 'miles';
export const CURRENCY = 'currency';
export const MPG = 'MPG';
export const MI = 'mi';

export const GROUPS_KEYS = {
  LOCATION_GROUP,
  MM_GROUP,
  YEAR_GROUP,
  CONDITION_GROUP,
  PRICE_PAYMENT_GROUP,
  CREDIT_PROVIDER_GROUP,
  RATING_GROUP,
  MILEAGE_GROUP,
  HISTORY_GROUP,
  MODEL_TYPE_GROUP,
  TRIM_GROUP,
  MPG_GROUP,
  EXT_COLOR_GROUP,
  INT_COLOR_GROUP,
  ELECTRIC_DETAILS_GROUP,
  ENGINE_GROUP,
  FEATURES_GROUP,
  OPTIONS_GROUP,
  VEHICLE_LISTING_DETAILS_GROUP,
  TRUCK_DETAILS_GROUP,
  EDITORIAL_RATING_GROUP,
};

export const SUBGROUP_KEYS = {
  PRICE_PAYMENT_TABS_SUBGROUP,
};
export const selfDrivingNameMap = {
  'Level 3': 'Conditional Automation',
  'Level 4': 'High Automation',
  'Level 5': 'Full Automation',
};
export const selfDrivingTooltipMap = {
  'Level 3':
    'The vehicle self-driving system offers complete hands and feet-free operation, including management of all steering, braking and acceleration, when operating under certain conditions (e.g. "on approved lane-marked road up to 50 MPH"). Driver must be alert and ready to takeover all driving tasks, including steering, braking and acceleration, when the vehicle has encountered a driving scenario it can no longer handle autonomously. The vehicle self-driving system must be certified as Level 3 in at least one state within the United States.',
  'Level 4':
    'The vehicle self-driving system offers complete hands and feet-free operation, including management of all steering, braking and acceleration, when operating under certain specified conditions. If the vehicle encounters conditions that the self-driving system can no longer operate the vehicle under (e.g. extreme weather), the vehicle will autonomously implement safety measures. No driver intervention is required. The vehicle self-driving system must be certified as Level 4 in at least one state within the United States.',
  'Level 5':
    'The vehicle self-driving system offers complete hands and feet-free operation, including management of all steering, braking and acceleration, when operating under any and all conditions. No driver intervention is required. The vehicle self-driving system must be certified as Level 5 in at least one state within the United States.',
};

export const FACETS_CONFIG = {
  [MAKE]: {
    title: null,
    label: 'Search by Make',
    control: FACETS_CONTROLS.SELECT,
    group: MM_GROUP,
    indexInsideGroup: 0,
    toggle: 'Add Make',
    creativeId: getFacetCreativeId('make_and_model'),
  },
  [MODEL]: {
    title: null,
    label: 'Search by Model',
    control: FACETS_CONTROLS.SELECT,
    group: MM_GROUP,
    indexInsideGroup: 1,
    toggle: 'Add Model',
    creativeId: getFacetCreativeId('make_and_model'),
  },
  [YEAR]: {
    title: null,
    label: 'Year(s)',
    control: FACETS_CONTROLS.RANGE,
    creativeId: getFacetCreativeId('year'),
    allowEqualValues: true,
    step: 1,
    filterClassName: 'mb-2',
    group: YEAR_GROUP,
  },
  [INVENTORY_TYPE]: {
    title: null,
    creativeId: getFacetCreativeId('condition'),
    control: FACETS_CONTROLS.CHECKBOX,
    group: CONDITION_GROUP,
  },
  [BODY_TYPE]: {
    title: 'Type',
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('type'),
    group: MODEL_TYPE_GROUP,
    indexInsideGroup: 0,
    withoutCollapse: true,
  },
  [VEHICLE_STYLE]: {
    title: 'Style',
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('type'),
    group: MODEL_TYPE_GROUP,
    indexInsideGroup: 1,
    withoutCollapse: true,
  },
  [EXTERIOR_COLOR]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('exterior_colors'),
    group: EXT_COLOR_GROUP,
    withoutCollapse: true,
  },
  [HISTORY_INFO]: {
    title: null,
    group: HISTORY_GROUP,
    control: FACETS_CONTROLS.CHECKBOX,
    withoutCollapse: true,
  },
  [EXCLUDE_HISTORY_INFO]: {
    title: 'Exclude vehicles with',
    group: HISTORY_GROUP,
    control: FACETS_CONTROLS.CHECKBOX,
    withoutCollapse: true,
  },
  [DEAL_TYPE]: {
    title: null,
    subtitle: {
      subtitleText: "Edmunds' ratings are backed by 15+ years of pricing research done by our data scientists",
      subtitleTooltip: {
        title: 'How are ratings determined?',
        text: 'We analyze millions of data points to generate our ratings. We look at vehicle configuration, options, history, nearby transactions, market pricing and more — the ratings are up-to-date and relevant to your search area.',
      },
    },
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('edmunds_deal_rating'),
    group: RATING_GROUP,
    labelPostfix: 'Price',
  },
  [EDITORIAL_RATING]: {
    group: EDITORIAL_RATING_GROUP,
    mergeInto: VEHICLE_RATING_SUBGROUP,
    indexInsideGroup: 0,
    itemsToShow: EDITORIAL_RATING_TO_SHOW,
    hideWhenAllValuesEmpty: true,
    creativeId: getFacetCreativeId('edmunds_editorial_rating'),
  },
  [EDMUNDS_TOP_RATED]: {
    group: EDITORIAL_RATING_GROUP,
    mergeInto: VEHICLE_RATING_SUBGROUP,
    indexInsideGroup: 1,
    creativeId: getFacetCreativeId('edmunds_editorial_rating'),
  },
  [EDITORIAL_LABEL]: {
    title: 'Expert Opinions',
    isSmallTitle: true,
    control: FACETS_CONTROLS.CHECKBOX,
    group: EDITORIAL_RATING_GROUP,
    indexInsideGroup: 1,
    maxOptionsBeforeCollapse: 4,
    creativeId: getFacetCreativeId('opinions'),
    noWidgetView: true,
    excludeZeroCount: true,
    hideWhenAllValuesEmpty: true,
    countClasses: '',
  },
  [FEATURE]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('features'),
    group: FEATURES_GROUP,
    maxOptionsBeforeCollapse: 3,
  },
  [TOTAL_SEATING]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('seating'),
    group: TOTAL_SEATING_GROUP,
    excludeZeroCount: true,
    withoutCollapse: true,
  },
  [SELF_DRIVING_LEVEL]: {
    title: 'Self-Driving',
    control: FACETS_CONTROLS.CHECKBOX,
    group: FEATURES_GROUP,
    indexInsideGroup: 0,
    maxOptionsBeforeCollapse: 3,
    getDisplayName(facet) {
      return selfDrivingNameMap[facet.name];
    },
    getValueName(facet) {
      return selfDrivingNameMap[facet.name];
    },
    getValueTooltip(facet) {
      return selfDrivingTooltipMap[facet.name];
    },
  },
  [COMFORT_CONVENIENCE]: {
    title: 'Comfort & Convenience',
    control: FACETS_CONTROLS.CHECKBOX,
    group: FEATURES_GROUP,
    indexInsideGroup: 1,
    maxOptionsBeforeCollapse: 3,
  },
  [SAFETY]: {
    title: 'Safety',
    control: FACETS_CONTROLS.CHECKBOX,
    group: FEATURES_GROUP,
    indexInsideGroup: 2,
    maxOptionsBeforeCollapse: 3,
  },
  [ENGINE_EXTERIOR]: {
    title: 'Engine & Exterior',
    control: FACETS_CONTROLS.CHECKBOX,
    group: FEATURES_GROUP,
    indexInsideGroup: 3,
    maxOptionsBeforeCollapse: 3,
  },
  [ENTERTAINMENT]: {
    title: 'Entertainment',
    control: FACETS_CONTROLS.CHECKBOX,
    group: FEATURES_GROUP,
    indexInsideGroup: 4,
    maxOptionsBeforeCollapse: 3,
  },
  [INTERIOR_COLOR]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('interior_colors'),
    group: INT_COLOR_GROUP,
    getDisplayName(facet) {
      return `${facet.name} Interior`;
    },
    withoutCollapse: true,
  },
  [ELECTRICITY_RANGE]: {
    title: 'EPA Range',
    tooltip: {
      id: 'epa-range-explanation',
      text: 'For new vehicles, this is the distance you can expect to travel on a full charge. EPA advises this range should be used for comparison purposes only. Actual range will vary depending on the condition of this vehicle’s battery pack, how you drive, driving conditions and other factors.',
    },
    control: FACETS_CONTROLS.RANGE,
    creativeId: getFacetCreativeId('electricityRange'),
    group: ELECTRIC_DETAILS_GROUP,
    labelType: MI,
    labelPostfix: ` ${MI}`,
    indexInsideGroup: 0,
    step: 1,
  },
  [BATTERY_RANGE_SCORE]: {
    title: 'Battery Range Score',
    tooltip: {
      id: 'battery-range-explanation',
      text: 'Range Score is based on this vehicle’s current Estimated Range and Recurrent Motors’ comparison of that Estimated Range with its estimated range when new.',
    },
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('battery_score'),
    group: ELECTRIC_DETAILS_GROUP,
    indexInsideGroup: 1,
    getDisplayName(facet) {
      return `${facet.name} Range Score`;
    },
    getPixelDisplayName(facet) {
      return `${facet.name} Range Score`;
    },
  },
  [EV_ELIGIBLE]: {
    title: 'EV Rebates',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ELECTRIC_DETAILS_GROUP,
    indexInsideGroup: 2,
  },
  [CYLINDERS_COUNT]: {
    title: 'Cylinders',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ENGINE_GROUP,
    indexInsideGroup: 3,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [TRANSMISSION]: {
    title: 'Transmission',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ENGINE_GROUP,
    indexInsideGroup: 0,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [DRIVE_TRAIN]: {
    title: 'Drivetrain',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ENGINE_GROUP,
    indexInsideGroup: 2,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [FUEL_TYPE]: {
    title: 'Fuel Type',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ENGINE_GROUP,
    indexInsideGroup: 4,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [ENGINE_TYPE]: {
    title: 'Engine Type',
    control: FACETS_CONTROLS.CHECKBOX,
    group: ENGINE_GROUP,
    indexInsideGroup: 1,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [OPTION]: {
    title: 'Options',
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('options_and_packages'),
    group: OPTIONS_GROUP,
    indexInsideGroup: 0,
    maxOptionsBeforeCollapse: 3,
  },
  [SPECIAL_IDENTIFIER]: {
    title: 'Trim Packages',
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('options_and_packages'),
    group: OPTIONS_GROUP,
    indexInsideGroup: 1,
    maxOptionsBeforeCollapse: 3,
  },
  [TRIM]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    creativeId: getFacetCreativeId('trim'),
    group: TRIM_GROUP,
    withoutCollapse: true,
  },
  [MILEAGE]: {
    title: null,
    label: 'Mileage',
    control: FACETS_CONTROLS.RANGE,
    creativeId: getFacetCreativeId('mileage'),
    group: MILEAGE_GROUP,
    appendZeroOption: true,
    labelType: MILES,
    step: 1000,
    filterClassName: 'mb-2',
  },
  [DISPLAY_PRICE]: {
    title: 'Price',
    control: FACETS_CONTROLS.RANGE,
    group: PRICE_PAYMENT_GROUP,
    subgroup: PRICE_PAYMENT_TABS_SUBGROUP,
    appendZeroOption: true,
    labelType: CURRENCY,
    creativeId: getFacetCreativeId('price_and_payments'),
    step: 1000,
    filterClassName: 'mb-2',
    filterOnSelect: { type: PAYMENT_TYPE, value: '' },
    dataTrackingId: 'view_purchase_pricing',
    withHistogram: true,
  },
  [LOAN_PAYMENT]: {
    title: 'Loan',
    control: FACETS_CONTROLS.RANGE,
    group: PRICE_PAYMENT_GROUP,
    subgroup: PRICE_PAYMENT_TABS_SUBGROUP,
    indexInsideGroup: 0,
    disclaimer: 'Assumes no money down and a 60-month term. Click a vehicle for more details.',
    prefix: 'Up to',
    postfix: 'per month',
    appendZeroOption: true,
    labelType: CURRENCY,
    creativeId: getFacetCreativeId('price_and_payments'),
    labelPostfix: '/mo',
    step: 10,
    filterClassName: 'mb-2',
    filterOnSelect: { type: PAYMENT_TYPE, value: 'loan' },
    dataTrackingId: 'view_loan_pricing',
    withHistogram: true,
  },
  [LEASE_PAYMENT]: {
    title: 'Lease',
    control: FACETS_CONTROLS.RANGE,
    group: PRICE_PAYMENT_GROUP,
    subgroup: PRICE_PAYMENT_TABS_SUBGROUP,
    indexInsideGroup: 0,
    disclaimer: 'Assumes $1K due at signing. Click a vehicle for more details.',
    prefix: 'Up to',
    postfix: 'per month',
    appendZeroOption: true,
    labelType: CURRENCY,
    creativeId: getFacetCreativeId('price_and_payments'),
    labelPostfix: '/mo',
    step: 10,
    filterClassName: 'mb-2',
    filterOnSelect: { type: PAYMENT_TYPE, value: 'lease' },
    dataTrackingId: 'view_lease_pricing',
    withHistogram: true,
  },
  [RADIUS]: {
    title: null,
    label: 'Search radius',
    control: FACETS_CONTROLS.RADIUS_SLIDER,
    group: LOCATION_GROUP,
    indexInsideGroup: 1,
    creativeId: getFacetCreativeId('zip_and_radius'),
    labelPostfix: 'mi',
    filterClassName: 'mb-2',
  },
  [DELIVERY_TYPE]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    creativeId: getFacetCreativeId('available_for_delivery'),
    group: LOCATION_GROUP,
    indexInsideGroup: 1,
    withoutCollapse: true,
  },
  [HOME_DELIVERY]: {
    title: null,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    creativeId: getFacetCreativeId('available_for_delivery'),
    group: LOCATION_GROUP,
    indexInsideGroup: 0,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [RECENTLY_LISTINGS]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 0,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [PRICE_DROP]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 1,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [WITH_PHOTO]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 2,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [WITH_PRICE]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 3,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [EXCLUDE_IN_TRANSIT]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 4,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [WITH_FEES_INCLUDED]: {
    group: VEHICLE_LISTING_DETAILS_GROUP,
    indexInsideGroup: 5,
    control: FACETS_CONTROLS.CHECKBOX,
    hideCount: true,
    filterClassName: 'mb-0_75',
    withoutCollapse: true,
  },
  [COMBINE_MPG]: {
    title: null,
    label: 'MPG',
    alternativeTitle: 'MPG/e',
    control: FACETS_CONTROLS.RANGE,
    creativeId: getFacetCreativeId('combinedMPG'),
    group: MPG_GROUP,
    labelType: MPG,
    labelPostfix: ` ${MPG}`,
    indexInsideGroup: 0,
    step: 1,
    filterClassName: 'mb-2',
  },
  [TRUCK_CAB_SIZE]: {
    title: 'Cabin Size',
    control: FACETS_CONTROLS.CHECKBOX,
    group: TRUCK_DETAILS_GROUP,
    indexInsideGroup: 0,
    withoutCollapse: true,
  },
  [BED_LENGTH]: {
    title: 'Bed Length',
    control: FACETS_CONTROLS.CHECKBOX,
    group: TRUCK_DETAILS_GROUP,
    indexInsideGroup: 1,
    withoutCollapse: true,
  },
  [DISPLACEMENT]: {
    title: 'Displacement',
    control: FACETS_CONTROLS.CHECKBOX,
    group: TRUCK_DETAILS_GROUP,
    indexInsideGroup: 2,
    maxOptionsBeforeCollapse: 3,
    withoutCollapse: true,
  },
  [REAR_WHEELS]: {
    title: 'Rear Wheels',
    control: FACETS_CONTROLS.CHECKBOX,
    group: TRUCK_DETAILS_GROUP,
    indexInsideGroup: 3,
    withoutCollapse: true,
  },
  [CREDIT_PROVIDER]: {
    title: null,
    creativeId: getFacetCreativeId('financing'),
    copy: 'Dealers that accept my prequalification',
    control: FACETS_CONTROLS.SWITCH,
    group: CREDIT_PROVIDER_GROUP,
  },
  [SELLER_TYPE]: {
    title: 'Seller Type',
    control: FACETS_CONTROLS.CHECKBOX,
    group: SELLER_TYPE_GROUP,
  },
};

export const EXPANDED_FILTERS = [LOCATION_GROUP];

// When change order, please move value/key pair correspondingly for readability
export const FACETS_GROUPS_CONFIG = {
  [LOCATION_GROUP]: {
    title: 'Location',
    order: 0,
    creativeId: getFacetCreativeId('zip_and_radius'),
  },
  [MM_GROUP]: {
    title: 'Make & Model',
    creativeId: getFacetCreativeId('make_and_model'),
    order: 1,
  },
  [YEAR_GROUP]: {
    title: 'Year',
    order: 1,
  },
  [CONDITION_GROUP]: {
    title: 'New / Used',
    order: 2,
  },
  [PRICE_PAYMENT_GROUP]: {
    title: 'Price & Payments',
    creativeId: getFacetCreativeId('price_and_payments'),
    order: 3,
  },
  [CREDIT_PROVIDER_GROUP]: {
    title: 'Financing',
    creativeId: getFacetCreativeId('financing'),
    order: 4,
  },
  [RATING_GROUP]: {
    title: 'Price Rating',
    order: 5,
  },
  [MODEL_TYPE_GROUP]: {
    title: 'Body Type',
    withInnerDividers: true,
    order: 6,
  },
  [TRIM_GROUP]: {
    title: 'Trim',
    order: 7,
  },
  [TRUCK_DETAILS_GROUP]: {
    title: 'Truck Details',
    withInnerDividers: true,
    creativeId: getFacetCreativeId('truck_details'),
    order: 8,
  },
  [MILEAGE_GROUP]: {
    title: 'Mileage',
    order: 9,
  },
  [HISTORY_GROUP]: {
    title: 'Accidents & History',
    creativeId: getFacetCreativeId('vehicle_history'),
    order: 10,
  },
  [ELECTRIC_DETAILS_GROUP]: {
    title: 'EV Details',
    withInnerDividers: true,
    creativeId: getFacetCreativeId('ev_details'),
    order: 11,
  },
  [ENGINE_GROUP]: {
    title: 'Engine & Drivetrain',
    withInnerDividers: true,
    creativeId: getFacetCreativeId('engine_mechanics'),
    order: 12,
  },
  [EXT_COLOR_GROUP]: {
    title: 'Exterior Color',
    order: 13,
  },
  [INT_COLOR_GROUP]: {
    title: 'Interior Color',
    order: 14,
  },
  [TOTAL_SEATING_GROUP]: {
    title: 'Total Seating',
    order: 15,
  },
  [EDITORIAL_RATING_GROUP]: {
    title: 'Edmunds Review',
    legendConfig: {
      titleClassNames: 'd-inline',
    },
    withInnerDividers: true,
    adornmentGroupConfig: {
      component: EdmundsTested,
      props: {
        className: 'mb-1',
        tooltip: {
          id: 'rating-scorecard-tooltip',
          title: 'Edmunds Review',
          iconClassName: 'text-cool-gray-10 size-12',
          text: 'The Edmunds Vehicle Testing Team evaluates a fresh batch of vehicles every week, pairing objective assessments at our test track with real-world driving on city streets, freeways and winding roads. The data we gather results in our Expert Ratings. They’re based on 30-plus scores that cover every aspect of the automotive experience.',
        },
      },
    },
    order: 16,
    creativeId: getFacetCreativeId('edmunds_editorial_rating'),
  },
  [FEATURES_GROUP]: {
    title: 'Features',
    withInnerDividers: true,
    creativeId: getFacetCreativeId('features'),
    order: 17,
  },
  [OPTIONS_GROUP]: {
    title: 'Options & Packages',
    withInnerDividers: true,
    order: 18,
  },
  [MPG_GROUP]: {
    title: 'MPG',
    order: 19,
  },
  [VEHICLE_LISTING_DETAILS_GROUP]: {
    title: 'Listing Details',
    creativeId: getFacetCreativeId('recently_listings'),
    order: 20,
  },
  [SELLER_TYPE_GROUP]: {
    title: 'Seller Type',
    order: 21,
  },
};

export const FACETS_GROUPS_CONFIG_SHOP_5157 = {
  ...FACETS_GROUPS_CONFIG,
  [YEAR_GROUP]: {
    ...FACETS_GROUPS_CONFIG[YEAR_GROUP],
    order: 1,
  },
  [MM_GROUP]: {
    ...FACETS_GROUPS_CONFIG[MM_GROUP],
    order: 2,
  },
  [TRIM_GROUP]: {
    ...FACETS_GROUPS_CONFIG[TRIM_GROUP],
    order: 3,
  },
  [PRICE_PAYMENT_GROUP]: {
    ...FACETS_GROUPS_CONFIG[PRICE_PAYMENT_GROUP],
    order: 4,
  },
  [CREDIT_PROVIDER_GROUP]: {
    ...FACETS_GROUPS_CONFIG[CREDIT_PROVIDER_GROUP],
    order: 5,
  },
  [MILEAGE_GROUP]: {
    ...FACETS_GROUPS_CONFIG[MILEAGE_GROUP],
    order: 6,
  },
  [CONDITION_GROUP]: {
    ...FACETS_GROUPS_CONFIG[CONDITION_GROUP],
    order: 7,
  },
  [HISTORY_GROUP]: {
    ...FACETS_GROUPS_CONFIG[HISTORY_GROUP],
    order: 8,
  },
  [ENGINE_GROUP]: {
    ...FACETS_GROUPS_CONFIG[ENGINE_GROUP],
    order: 9,
  },
  [MODEL_TYPE_GROUP]: {
    ...FACETS_GROUPS_CONFIG[MODEL_TYPE_GROUP],
    order: 10,
  },
  [TRUCK_DETAILS_GROUP]: {
    ...FACETS_GROUPS_CONFIG[TRUCK_DETAILS_GROUP],
    order: 11,
  },
  [ELECTRIC_DETAILS_GROUP]: {
    ...FACETS_GROUPS_CONFIG[ELECTRIC_DETAILS_GROUP],
    order: 12,
  },
  [EXT_COLOR_GROUP]: {
    ...FACETS_GROUPS_CONFIG[EXT_COLOR_GROUP],
    order: 13,
  },
  [INT_COLOR_GROUP]: {
    ...FACETS_GROUPS_CONFIG[INT_COLOR_GROUP],
    order: 14,
  },
  [FEATURES_GROUP]: {
    ...FACETS_GROUPS_CONFIG[FEATURES_GROUP],
    order: 15,
  },
  [OPTIONS_GROUP]: {
    ...FACETS_GROUPS_CONFIG[OPTIONS_GROUP],
    order: 16,
  },
  [RATING_GROUP]: {
    ...FACETS_GROUPS_CONFIG[RATING_GROUP],
    order: 17,
  },
  [EDITORIAL_RATING_GROUP]: {
    ...FACETS_GROUPS_CONFIG[EDITORIAL_RATING_GROUP],
    order: 18,
  },
  [TOTAL_SEATING_GROUP]: {
    ...FACETS_GROUPS_CONFIG[TOTAL_SEATING_GROUP],
    order: 19,
  },
  [MPG_GROUP]: {
    ...FACETS_GROUPS_CONFIG[MPG_GROUP],
    order: 20,
  },
  [VEHICLE_LISTING_DETAILS_GROUP]: {
    ...FACETS_GROUPS_CONFIG[VEHICLE_LISTING_DETAILS_GROUP],
    order: 21,
  },
  [SELLER_TYPE_GROUP]: {
    ...FACETS_GROUPS_CONFIG[SELLER_TYPE_GROUP],
    order: 22,
  },
};

export const FACETS_SUBGROUPS_CONFIG = {
  [DELIVERY_SUBGROUP]: { group: LOCATION_GROUP, indexInsideGroup: 2, control: FACETS_CONTROLS.CHECKBOX },
  [LISTING_DETAILS]: { group: VEHICLE_LISTING_DETAILS_GROUP, indexInsideGroup: 0, control: FACETS_CONTROLS.CHECKBOX },
  [VEHICLE_RATING_SUBGROUP]: {
    group: EDITORIAL_RATING_GROUP,
    indexInsideGroup: 0,
    control: FACETS_CONTROLS.CHECKBOX,
    title: 'Vehicle Rating',
    subtitle: {
      subtitleText: 'We drove it! Our ratings are based on our Edmunds expert’s extensive vehicle testing.',
      subtitleClassNames: 'mb-0_75',
    },
  },
};
